import { useCallback, useState } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Column, Select } from 'components/Blocks';

import { SingleInvoiceControlCancelRequest } from './Request';
import { TriStateWrapper } from '../components';

import { usePendingActions } from 'providers/PendingActions';

import { compareByName, getFirst, listGet, listRemove, sortByProperty } from 'utils/array';

export function InvoiceControlCancelation() {
  const { t } = useLang();

  const { decreaseCount } = usePendingActions();

  const [selected, setSelected] = useState('');

  const {
    data: requests,
    loading,
    overwrite,
  } = loaders.invoice.invoiceControlCancelRequests.use({
    defaultValue: [],

    onDataChange: (list) => setSelected((old) => (list.length && !old ? getFirst(list).id : old)),

    parser: (list) => sortByProperty(list, 'project', { project: compareByName }),
  });

  const removeRequest = useCallback(
    (id: string) => {
      overwrite((old) => listRemove(old, id));

      decreaseCount('INVOICE_CONTROL_CANCEL_REQUESTS');
    },
    [overwrite, decreaseCount],
  );

  const request = listGet(requests, selected);

  return (
    <TriStateWrapper loading={loading} message={!requests.length && t('no-data')}>
      <Column className="mx-auto w-[min(80%,850px)] phone:w-full">
        <Select
          value={selected}
          onChangeDirect={setSelected}
          options={requests.map((req) => ({
            label: req.project.name,
            value: req.id,
          }))}
        />

        {!!request && (
          <SingleInvoiceControlCancelRequest
            key={request.id}
            request={request}
            removeSelf={() => removeRequest(request.id)}
          />
        )}
      </Column>
    </TriStateWrapper>
  );
}
